interface DropConfigDates {
	drop_start_date?: string | null;
	checkout_end_date?: string | null;
}

interface WithDropPage {
	release_date?: string | null;
	drop_page?: {
		drop_config?: (DropConfigDates | null)[] | null;
	} | null;
}

/**
 * The date an artist-page card sorts by.
 *
 * `release_date` is authoritative, but plenty of series and primary collections
 * leave it unset while still having a drop scheduled. Those fall back to the
 * drop config — its start date, or the checkout end date when the drop has no
 * start. `drop_config` is a to-many relation, so the earliest date across all
 * configs is used, which is when the group first went live.
 *
 * Returns null when nothing is known; callers sort those last.
 */
export const getCatalogueCardDate = (
	item: WithDropPage | null | undefined
): string | null => {
	if (item?.release_date) {
		return item.release_date;
	}

	const dropDates = (item?.drop_page?.drop_config || [])
		.map((config) => config?.drop_start_date || config?.checkout_end_date)
		.filter((date): date is string => Boolean(date))
		.sort();

	return dropDates[0] ?? null;
};
